import http from './_http';
import httpClient from '@/core/svc-client/_http';
import { logWebHrError } from '@/core/logger/log-wrapper';

async function getFileUpload(onboardingId, fileId) {
  const { data } = await http.get(
    `/fileupload/${onboardingId}/field/${fileId}`
  );
  return data.data || [];
}

async function getAllFileUpload(onboardingId) {
  const { data } = await http.get(`/fileupload/${onboardingId}`);
  return data.data || [];
}

/**
 * @param onboardingId {String}
 * @param fieldId {String}
 */
async function deleteFileUpload(onboardingId, fieldId) {
  const { data } = await http.delete(
    `/fileupload/${onboardingId}/field/${fieldId}`
  );
  return data.data || [];
}

/**
 *
 * @param payload {Object}
 * @param payload.onboardingId {String}
 * @param payload.fieldId {String}
 * @param payload.fileLabel {String}
 * @param payload.sizeInBytes {Integer}
 * @param payload.type {String}
 * @param payload.base64 {String}
 * @param payload.uploadCategory {Integer}
 * @param progressFunction {Function}
 * @returns {Promise<void>}
 */
async function requestFileUpload(payload, progressFunction) {
  const {
    onboardingId,
    fieldId,
    fileLabel,
    sizeInBytes,
    type,
    base64,
    uploadCategory,
  } = payload;

  try {
    await httpClient.post(
      `/fileupload/${onboardingId}/field/${fieldId}`,
      {
        name: fileLabel,
        sizeInBytes,
        type,
        content: base64,
        uploadCategory,
      },
      {
        onUploadProgress({ loaded, total }) {
          progressFunction({ loaded, total });
        },
      }
    );
  } catch (e) {
    logWebHrError({
      message: 'Failed to upload file at fileupload',
      source: 'file-upload',
      metadata: {
        onboardingId,
        fileLabel,
        fieldId,
        sizeInBytes,
        type,
        hasBase64: !!base64,
        uploadCategory,
      },
      error: e,
    });
    throw e;
  }
}

export { getFileUpload, getAllFileUpload, deleteFileUpload, requestFileUpload };
